import React from "react";
import "./css/modal.css";
import PropTypes from "prop-types";

const Modal = ({ selectedCharacter = [] }) => {
  return (
    <div
      className="modal fade"
      id="fullscreenModal"
      tabIndex="-1"
      aria-labelledby="fullscreenModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body">

            <div className="container">
              <div className="row g-4 justify-content-center">

                {selectedCharacter.map((item) => (
                  <div
                    key={item.id}
                    className="col-12 col-md-6 col-lg-4 d-flex justify-content-center"
                  >
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="size-image-modal-hv "
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>
                  </div>
                ))}

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  selectedCharacter: PropTypes.array,
};

export default Modal;
